angular.module('impactx.address').controller('IxBasketAddressDialogInputController',
    ['TranslationService',
    IxBasketAddressDialogInputController]);

function IxBasketAddressDialogInputController(TranslationService) {
    var ctrl = this;
    ctrl.formatAddressValue = function (value) {
        if(value) {
            return value.replace(/,\s/g, '<br/>')
        }
        return '';
    }
    ctrl.selectLabel = TranslationService.get("select");
}
